<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-group">
	<!--  	   	 	    -->
	<!-- HEADER SECTION -->
	<!-- 			    -->
	<div class="header-group">
		<div class="header-item">
			<div style="margin-left: 20px">
				<label style="width: 100px">Deny Entry for</label>
			</div>

			<div style="margin-left: 0px">
				<p-radioButton
					name="group1"
					[disabled]="UserLevelID != 1"
					value="1"
					label="All Sites"
					[(ngModel)]="selectedGroupValue"
					(ngModelChange)="onGroupChange($event)"
				></p-radioButton>
			</div>

			<div style="margin-left: 10px">
				<p-radioButton
					name="group1"
					value="2"
					label="Facility"
					[(ngModel)]="selectedGroupValue"
					(ngModelChange)="onGroupChange($event)"
				></p-radioButton>
			</div>

			<!--  	   	           -->
			<!-- Facility Selector -->
			<!-- 		           -->
			<div style="margin-left: 10px; width: 153px" [style.display]="selectedGroupValue == '2' ? 'block' : 'none'">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="SelectedFacilitySelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedFacility"
					(ngModelChange)="onFacilityChange($event)"
				>
					<option *ngFor="let r of lstFacilityItems" [ngValue]="r">{{ r.FacilityCD }} - {{ r.FacilityName }}</option>
				</select>
			</div>

			<!--  	           -->
			<!-- Info Selector -->
			<!-- 	           -->
			<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
		</div>

		<div class="header-item" style="margin-top: 10px">
			<div style="margin-left: 20px">
				<label style="width: 100px">Select Block List</label>
			</div>

			<div style="margin-left: 0px">
				<!-- Block List File Selector Button -->
				<label for="fileSelectBlocked" class="btn btn-primary" style="margin-left: 0px">...</label>
				<input
					id="fileSelectBlocked"
					type="file"
					(change)="onLoadBlockList($event)"
					onclick="event.target.value=''"
					style="visibility: hidden; position: absolute"
					accept=".txt,.csv,.tab*"
				/>
			</div>

			<div style="margin-left: 20px">
				<input type="checkbox" name="chkSkipFirstRow" [(ngModel)]="isSkipFirstRow" (ngModelChange)="chkSkipFirstRow($event)" ngDefaultControl />
			</div>

			<div style="margin-left: 10px">
				<label>Ignore first row when selecting block list</label>
			</div>

			<div style="margin-left: 20px">
				<label> {{ lstBlockItems.length }} Record(s) Loaded </label>
			</div>
		</div>

		<div class="header-item" style="margin-top: 10px">
			<div style="margin-left: 20px">
				<label style="width: 100px">Select Photos</label>
			</div>

			<div style="margin-left: 0px">
				<!-- Photo Selector Button -->
				<label for="photoSelectBlocked" class="btn btn-primary" style="margin-left: 0px">...</label>
				<input
					id="photoSelectBlocked"
					type="file"
					(change)="onLoadPhotos($event)"
					onclick="event.target.value=''"
					[disabled]="SelectedCounts[3] == 1"
					style="visibility: hidden; position: absolute"
					accept="image/*"
					multiple
				/>
			</div>

			<div style="margin-left: 20px" [style.display]="SelectedCounts[3] == 1 ? 'block' : 'none'">
				<label>
					Please wait while loading images...
					{{ SelectedCounts[1] }} of {{ SelectedCounts[0] }} / ({{ (SelectedCounts[1] / SelectedCounts[0]) * 100 | number : "1.0-0" }}%)
				</label>
			</div>

			<div style="margin-left: 20px" [style.display]="SelectedCounts[1] > 0 && SelectedCounts[3] != 1 ? 'block' : 'none'">
				<label> {{ SelectedCounts[1] }} Image(s) Loaded </label>
			</div>
		</div>

		<div class="header-item" style="margin-top: 10px" [style.display]="isShowInfo == true ? 'block' : 'none'">
			<div style="margin-left: 30px; margin-right: 30px">
				<label
					>&#9900; Select the Don't import top row if you know the top row should not be imported (an import file may include the column names at the
					top for easier matching).</label
				><br />
				<label
					>&#9900; Click the Select Block List ellipsis button, and select the file from the file explorer dialogue box. The fields will populate the
					open area of the form. Now you can select the appropriate field for each column. Change the default header, Don't Import, for each known
					column.</label
				><br />
				<label
					>&#9900; Available fields from the column header dropdown are all those found in the data entry screen of the Add Blocked Visitor form. An
					exception is the Photo column. In order to import one or more photos, you simply list the photo names in one of the columns, ie.,
					BettyBarnes.jpg.</label
				><br />
				<label
					>&#9900; Click the Select Photos ellipsis button, and select the images from the file explorer dialogue box. From the search dialogue it is
					possible to select multiple files by holding down the shift key.</label
				><br />
				<label
					>&#9900; Images whose names match the photo column's text will be marked 'YES' in the Photo Loaded column. Text items that don't match any
					image names will be left blank.</label
				><br />
			</div>
		</div>
	</div>

	<!--  	   	 			 -->
	<!-- IMPORT LIST SECTION -->
	<!-- 			 		 -->
	<div class="list-group">
		<p-table [columns]="lstColumns" [value]="lstBlockItems" [scrollable]="true" scrollHeight="300px">
			<ng-template pTemplate="colgroup" let-columns>
				<colgroup>
					<col *ngFor="let col of columns" style="width: 125px" />
				</colgroup>
			</ng-template>

			<ng-template pTemplate="header" let-columns>
				<tr>
					<th *ngFor="let col of columns; let indexOfelement = index">
						<div *ngIf="indexOfelement == 0">
							<label>Photo Loaded</label>
						</div>

						<div *ngIf="indexOfelement > 0">
							<select class="form-control" id="{{ col }}" style="font-size: smaller" (change)="onImportItemChange($event)">
								<option *ngFor="let r of lstImportItems" [ngValue]="r">
									{{ r.ImportItemName }}
								</option>
							</select>
						</div>
					</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-lstBlockItems>
				<tr>
					<td *ngFor="let r of lstBlockItems">
						{{ r }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="error-group">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onImportBlock()" [disabled]="isBusy == true || SelectedCounts[3] == 1">Import</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
